import getRequiredError from "../../../../bootstrap/components/custom-form/error-checking/utils/getRequiredError";

let $value, $rules, $options, $allValues;

export default function (value, rules, options, allValues) {
    $value = value;
    $rules = rules;
    $options = options;
    $allValues = allValues;

    return checkRequired();
}

function checkRequired() {
    if ($value !== null) {
        return null;
    }

    return getRequiredError($rules, $options, $allValues);
}
